var decoders = exports;

decoders.der = require('./der');
decoders.pem = require('./pem');



//////////////////
// WEBPACK FOOTER
// ./~/asn1.js/lib/asn1/decoders/index.js
// module id = 2055
// module chunks = 0